import { useMemo } from "react";
import { ProductImage } from "../videoCreatingSlice";
import { imageHasDescription } from "../type";

/**
 * 判断是否需要 AI 分析图片
 * @param images - 图片列表
 * @returns 需要 AI 分析的图片列表
 */
export function useNeedAiAnalyzeImages(images: ProductImage[]) {
  const needAiAnalyzeImages = useMemo(
    // 原则1: 只要页面上有任何一张图片没经过 AI 检测，都不允许用户进入下一步，页面上只有“AI Analyze”按钮能点。
    // 原则2: 只要页面上有任何一张图片的“标签”字段（description field）为空，都不允许用户进入下一步，页面上只有“AI Analyze”按钮能点。
    () => images.filter((image) => !image.aiAnalyzed || !imageHasDescription(image)),
    [images],
  );
  return needAiAnalyzeImages;
}
